<template>
  <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-row class="no-gutters">
      <v-col cols="12" sm="6" md="6" lg="3">
        <v-text-field
          v-model="search"
          prepend-icon="mdi-magnify"
          label="Search here ..."
          single-line
          solo
          hide-details
        />
      </v-col>

      <v-col cols="12" sm="6" md="6" lg="3">
        <ul>
          <li>
            <span class="profit-loss">Total Withdraw:</span>
            <span>${{
              wallettransactions?.totalWithdraw?.toFixed(2)
            }}</span>
          </li>
        </ul>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card
          class="pa-3 rounded-0 elevation-0"
          :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'"
        >
          <v-sheet
            class="transactionTable liveTradeTable walletTable pb-3"
            :color="$vuetify.theme.dark ? '#1A2A3E' : '#F1F7FB'"
          >
            <v-data-table
              :headers="headers"
              :items="filteredData"
              :search="search"
              :items-per-page="10"
            >
              <!-- Date -->
              <template v-slot:item.updated_at="{ item }">
                {{ formatMySQLDate(item.updated_at) }}
              </template>

              <!-- Amount -->
              <template v-slot:item.amount="{ item }">
                $ {{ Number(item.amount).toFixed(2) }}
              </template>

              <!-- <template v-slot:item.withdraw_method="{ item }">
                    <v-chip
                        small
                        outlined
                        :color="item.withdraw_method === 'Crypto' ? 'blue' : 'green'"
                    >
                        <v-icon left small>
                        {{ item.withdraw_method === 'Crypto'
                            ? 'mdi-currency-btc'
                            : 'mdi-bank' }}
                        </v-icon>
                        {{ item.withdraw_method || '—' }}
                    </v-chip>
                </template> -->

                <template v-slot:item.withdraw_method="{ item }">
                  <v-chip
                    small
                    outlined
                    :color="
                      item.withdraw_method === 'Crypto'
                        ? 'blue'
                        : item.withdraw_method === 'Cash'
                        ? 'orange'
                        : 'green'
                    "
                  >
                    <v-icon left small>
                      {{
                        item.withdraw_method === 'Crypto'
                          ? 'mdi-currency-btc'
                          : item.withdraw_method === 'Cash'
                          ? 'mdi-cash'
                          : 'mdi-bank'
                      }}
                    </v-icon>
                    {{ item.withdraw_method || '—' }}
                  </v-chip>
                </template>


              <!-- Manager Account -->
              <template v-slot:item.manager_account="{ item }">
                {{ item.manager_account || "—" }}
              </template>

              <!-- Profit Sharing -->
              <template v-slot:item.profit_sharing="{ item }">
                {{ item.profit_sharing !== null ? item.profit_sharing + "%" : "—" }}
              </template>

              <!-- Manager Commission -->
              <template v-slot:item.manager_commission="{ item }">
                $ {{ Number(item.manager_commission || 0).toFixed(2) }}
              </template>

              <!-- Final Investor Withdraw -->
              <template v-slot:item.final_inv_withdraw="{ item }">
                $ {{ Number(item.final_inv_withdraw || 0).toFixed(2) }}
              </template>

              <!-- Status -->
              <template v-slot:item.status="{ item }">

                <div :class="verifyIcon(item?.status)">

                    <v-icon small></v-icon>

                {{ item?.status }}

                </div>
              </template>

              <!-- Trx Type -->
              <template v-slot:item.trx_type="{ item }">
                {{ item.trx_type || "Internal Transfer" }}
              </template>

              <!-- Account No -->
              <template v-slot:item.acc_no="{ item }">
                {{ item.acc_no || item.from_acc_no || "—" }}
              </template>

              <!-- Transaction Fee -->
              <template v-slot:item.transaction_fee="{ item }">
                $ {{
                  item.transaction_fee === 0
                    ? "0.00"
                    : item.transaction_fee
                    ? Number(item.transaction_fee).toFixed(2)
                    : "N/A"
                }}
              </template>

              <!-- Net Amount -->
              <template v-slot:item.net_amount="{ item }">
                $ {{
                  item.net_amount
                    ? Number(item.net_amount).toFixed(2)
                    : "N/A"
                }}
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { MAM__WALLET__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      headers: [
        { text: "Trx Type", value: "trx_type" },
        { text: "Date & Time", value: "updated_at" },
        { text: "Acc. No.", value: "acc_no" },
        { text: "Amount ($)", value: "amount" },
        { text: "Manager Acc.", value: "manager_account" },
        { text: "Profit Sharing (%)", value: "profit_sharing" },
        { text: "Manager Comm. ($)", value: "manager_commission" },
        { text: "Final Investor ($)", value: "final_inv_withdraw" },
        { text: "Withdraw Method", value: "withdraw_method" },
        { text: "Status", value: "status" },
      ],
      search: "",
      account: "",
      dates: [],
      filteredData: [],
    };
  },

  computed: {
    ...mapState("mamWallet", ["wallettransactions"]),
  },

  methods: {
    ...mapActions("mamWallet", [
      MAM__WALLET__ACTIONS.WALLETTRANSACTIONHISTORY,
    ]),

    formatMySQLDate(mysqlDate) {
      if (!mysqlDate) return "—";
      const d = new Date(mysqlDate);
      return d.toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },

    verifyIcon(status) {
        if (status === "Approved") return "mdi mdi-check text--green mr-1";
        else if (status === "Rejected")
            return "mdi mdi-window-close text-red mr-1";
        else return "mdi mdi-refresh mr-1 text-warning";
    },

    resetAll() {
      this.search = "";
      this.account = "";
      this.dates = [];
      this.filteredData = this.wallettransactions?.allTransactions || [];
    },
  },

  async mounted() {
    await this[MAM__WALLET__ACTIONS.WALLETTRANSACTIONHISTORY]();
    this.filteredData = this.wallettransactions?.allTransactions || [];
  },
};
</script>
